require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ./~/angular-messages/index.js
// module id = 372
// module chunks = 1